
<template>
	<v-btn 
		:color="color"
		:href="href"
		target="_blank"
		:title="title"
		v-bind="$attrs"
	>
		<slot>
			<v-icon class="mr-1">
				mdi-twitter
			</v-icon>
			Twitter
		</slot>
	</v-btn>
</template>

<script>

const nuxtConfig = require('~/nuxt.config').default

export default {
	data:() => ({
		color: undefined,
		href: undefined,
		title: undefined
	}),
	mounted() {
		let getParams = this.$attrs.params || ''
		this.color = this.$attrs.color || 'light-blue accent-1 white--text'
		this.url = `${nuxtConfig.hostname}${this.$route.fullPath}`
		this.href = this.$attrs.url ? `https://www.twitter.com/share?url=${this.$attrs.url}${getParams}` : `https://www.twitter.com/share?url=${this.url}${getParams}`
		this.title = this.$attrs.title || `แชร์ ${this.$attrs.url || this.url} บนทวีตเตอร์`
	}
}

</script>
